<template>
<div v-if="success == false">
  <div class="popupStyle-layout-1" style="height: auto; font-family: NanumSquareOTF;">
    <div class="title" style="margin-bottom: 44px;">
      정비 견적받기
    </div>
    <div class="title-area mb-32 mx-20" style="margin-bottom: 20px;">
      <h4 style="font-weight:bold; color:#666666;">차량정보 </h4>
      <element-select
        class="siri-selectbox"
        v-model="selectedCar.value"
        :label="selectedCar.label"
        :items="carInfo.items"
        :placeholder="carInfo.placeholder"
      ></element-select>
    </div>
    <div class="title-area mb-32 mx-20">
      <h4 style="font-weight:bold; color:#666666;">희망지역 </h4>
      <div v-if="address != ''" style="font-weight: bold; font-family: NanumSquareOTF;">
        {{ address }}
      </div>
      <button v-if="address == ''" class="add-address-btn" id="plus-address-btn" @click="addressSearch()">
        주소입력
      </button>
      <button v-else class="add-address-btn2" id="plus-address-btn" @click="addressSearch()">
        주소수정
      </button>
    </div>

    <div class="title-area mb-32 mx-20 ">
      <h4 style="font-weight:bold; color:#666666;">정비항목 (중복선택이 가능합니다) </h4>
      <div class="select-repairlist">

        <!-- 정비 항목 선택 -->
        <div v-for="(item, i) in repairlist" :key="i"
          class="repairlist-item" @click.prevent="item.value = !item.value">
          <el-checkbox v-model="repairlistcheck">
            <svg
              v-if="!item.value"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="#CCCCCC"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24C8.8174 24 5.76516 22.7357 3.51472 20.4853C1.26428 18.2348 0 15.1826 0 12C0 8.8174 1.26428 5.76516 3.51472 3.51472C5.76516 1.26428 8.8174 0 12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.8174 24 12ZM18.045 7.455C17.9379 7.34823 17.8103 7.26416 17.6699 7.20782C17.5295 7.15149 17.3792 7.12404 17.228 7.12712C17.0768 7.1302 16.9277 7.16375 16.7897 7.22575C16.6518 7.28776 16.5277 7.37695 16.425 7.488L11.2155 14.1255L8.076 10.9845C7.86274 10.7858 7.58067 10.6776 7.28922 10.6827C6.99776 10.6879 6.71969 10.8059 6.51357 11.0121C6.30745 11.2182 6.18938 11.4963 6.18424 11.7877C6.1791 12.0792 6.28728 12.3612 6.486 12.5745L10.455 16.545C10.5619 16.6517 10.6892 16.7358 10.8294 16.7923C10.9695 16.8487 11.1196 16.8764 11.2706 16.8736C11.4217 16.8708 11.5706 16.8376 11.7085 16.776C11.8465 16.7144 11.9706 16.6256 12.0735 16.515L18.0615 9.03C18.2656 8.81775 18.3784 8.53391 18.3756 8.23944C18.3728 7.94496 18.2546 7.66332 18.0465 7.455H18.045Z"
              />
            </svg>
            <svg
              v-if="item.value"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="#00CD34"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24C8.8174 24 5.76516 22.7357 3.51472 20.4853C1.26428 18.2348 0 15.1826 0 12C0 8.8174 1.26428 5.76516 3.51472 3.51472C5.76516 1.26428 8.8174 0 12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.8174 24 12ZM18.045 7.455C17.9379 7.34823 17.8103 7.26416 17.6699 7.20782C17.5295 7.15149 17.3792 7.12404 17.228 7.12712C17.0768 7.1302 16.9277 7.16375 16.7897 7.22575C16.6518 7.28776 16.5277 7.37695 16.425 7.488L11.2155 14.1255L8.076 10.9845C7.86274 10.7858 7.58067 10.6776 7.28922 10.6827C6.99776 10.6879 6.71969 10.8059 6.51357 11.0121C6.30745 11.2182 6.18938 11.4963 6.18424 11.7877C6.1791 12.0792 6.28728 12.3612 6.486 12.5745L10.455 16.545C10.5619 16.6517 10.6892 16.7358 10.8294 16.7923C10.9695 16.8487 11.1196 16.8764 11.2706 16.8736C11.4217 16.8708 11.5706 16.8376 11.7085 16.776C11.8465 16.7144 11.9706 16.6256 12.0735 16.515L18.0615 9.03C18.2656 8.81775 18.3784 8.53391 18.3756 8.23944C18.3728 7.94496 18.2546 7.66332 18.0465 7.455H18.045Z"
              />
            </svg>
          </el-checkbox>
          <p style="margin-left:10px;" v-html="item.name" />
        </div>
      </div>
    </div>

    <div class="title-area mb-32 mx-20 ">
      <div class="image-titlearea">
        <h4>정비부위 사진 (5mb이하) </h4>
        {{ uploadedArr.length }}/10
      </div>
      <button v-if="uploadedArr.length != 10" class="add-address-btn" id="plus-address-btn" @click="handleUpload()">
        +사진 추가
      </button>
      <button v-else-if="uploadedArr.length == 10" class="add-address-btn3" id="plus-address-btn">
        +사진 추가
      </button>
      <input
          style="display:none;"
          id="upload-none"
          type="file"
          accept="jpg, png, gif, pdf"
          @change="selectedFile"
      />
      <div class="add-picture">

        <div class="img-row">
          <div
              class="img-each"
              v-for="(i, index) in uploadedArr"
              :key="index"
          >
            <el-button
                type="info"
                icon="el-icon-close"
                size="mini"
                circle
                @click="deleteFile(index)"
            ></el-button>
            <img :src="i.result" alt="" />
          </div>
          <div v-if="uploadedArr.length < 1" class="imagebox" />
          <div v-if="uploadedArr.length < 2" class="imagebox" />
        </div>
      </div>
    </div>

    <div class="title-area mb-32 mx-20">
      <h4 style="font-weight:bold; color:#666666;">남기실 말씀 </h4>
      <textarea
        class="textarea-box-border"
        v-model="reservation_memo"
        type="text"
        maxlength="500"
        rows="5"
        placeholder="그 밖의 정비항목 또는 특별한 요구 사항이 있다면 입력해주세요"
      ></textarea>
    </div>
    <div class="title-area mb-32 mx-20">
      <h4 style="font-weight:bold; color:#666666;">연락받을 휴대폰번호 </h4>
      <input
        class="input-box-border"
        v-model="phoneNum"
        type="text"
        placeholder="휴대폰번호를 입력해주세요"
      />
    </div>
  </div>
  <!-- 하단부 버튼 -->
  <ButtonBottom
    v-if="btnDisabled == true"
    btnTitle="신청"
    :disabled="true"
    class="submit-btn"
    :click="clickNo">
  </ButtonBottom>
  <ButtonBottom
    v-else-if="btnDisabled == false"
    btnTitle="신청"
    :disabled="false"
    class="submit-btn"
    :click="clickApply">
  </ButtonBottom>

  <!-- 주소검색 다이어로그 -->
  <el-dialog
    :visible.sync="dialog"
    width="400px"
    title="주소검색"
    :show-close="false" >
    <vue-daum-postcode @complete="searchAddress($event)" />
	</el-dialog>
</div>
<!-- 신청 완료시 완료 화면 -->
  <Success v-else-if="success == true"
    contents="무료 비교견적을<br>신청했습니다."
    contentsWeak="입력하신 내용을 바탕으로<br>최저견적을 찾아 드리겠습니다.<br>견적이 나오면 카카오톡으로 알려드립니다."
    :customOK="clickOkay">
  </Success>
</template>

<script>
import ButtonBottom from '@/components/Elements/ButtonBottom';
import Success from '@/components/Elements/Success';
import { Checkbox, Dialog, Button } from 'element-ui';
import Vue from 'vue'
import {v4} from 'uuid'
import moment from 'moment'

Vue.component('ElCheckbox', Checkbox);
Vue.component('ElDialog', Dialog);
Vue.component('ElButton', Button);

export default {
  components: { ButtonBottom, Success },
  data() {
    return {
      repair_estimate_type: '정비',
      uploadedArr: [],
      deleteUploadedArr: [],
      autocode_name: '',
      auto_id: '',
      auto_code: '',
      resource_key: '',
      success: false,
      dialog: false,
      address: '',
      selectedCar: {
        label: '',
        value: ''
      },
      btnDisabled: true,
      repairlist: [
        { name: '엔진오일 및<br> 오일 필터', value: false },
        { name: '에어컨필터<br>(항균필터)', value: false },
        { name: '와이퍼 블레이더', value: false },
        { name: '구동벨트', value: false },
        { name: '미션 오일', value: false },
        { name: '배터리', value: false },
        { name: '보증수리', value: false },
        { name: '브레이크 오일', value: false },
        { name: '브레이크 패드 및<br> 디스크', value: false },
        { name: '사고수리', value: false },
        { name: '에어클리너 필터', value: false },
        { name: '엔진부동액<br>(냉각수)', value: false },
        { name: '연료필터', value: false },
        { name: '외장수리복원', value: false },
        { name: '타이밍 벨트', value: false },
        { name: '타이어', value: false },
        { name: '타이어 위치', value: false },
        { name: '타이어펑크수리', value: false },
        { name: '파워스티어링<br>오일', value: false },
        { name: '휠 얼라인먼트', value: false },
      ],
      reservation_memo: '',
      phoneNum: '',
      carInfo: {
        value: '',
        items: [],
        placeholder: '차량 선택',
      },
      repairCustomerId: '',
    }
  },
  created() {
    if (this.$store.state.customer.profile.customer_phone_number != '') {
      this.phoneNum = this.$store.state.customer.profile.customer_phone_number
    }
    this.init()
  },
  watch: {
    selectedCar () {
      if ( this.repairlist.filter( o => { return o.value == true } ).length != 0 && this.address != '' ) {
        this.btnDisabled = false
      }
    }
  },
  computed: {
    repairlistcheck () {
      if ( this.repairlist.filter( o => { return o.value == true } ).length != 0 && this.selectedCar != '' && this.address != '' ) {
        this.btnDisabled = false
      }
      return this.btnDisabled
    }
  },
  methods: {
    init() {
      this.repairEstimateId = this.$route.query.repairEstimateId
      this.get_repair_estimate(this.$route.query.repairEstimateId)
    },
    get_repair_estimate(id) {
      if (!id) {
        this.getAutoList(this.$route.query.customerId)
        return false
      }

      return this.$store.dispatch(`repair/get`, { repairId: id, search_customer_id: this.$store.state.customer.profile._id })
        .then(({data}) => {
          const {
            auto_id,
            auto_code,
            autocode_name,
            reservation_memo,
            repair_estimate_memo,
            repair_estimate_type,
            repair_estimate_date,
            desired_area, 
            resource_key,
            customer_id
          } = data.data
          
          this.address = desired_area
          this.selectedCar = {
            value: auto_id,
            label: autocode_name,
            _id: auto_id,
            auto_code,
          };
          this.reservation_memo = reservation_memo
          this.repair_estimate_memo = repair_estimate_memo
          this.resource_key = resource_key
          this.repair_estimate_type = repair_estimate_type
          this.repair_estimate_date = repair_estimate_date
          this.autocode_name = autocode_name
          this.auto_id = auto_id
          this.auto_code = auto_code
          this.load_list(data.data.resource_key)
          this.getAutoList(customer_id)
        });
    },
    getAutoList (customer_id) {
      const { profile } = this.$store.state.customer;

      if (!profile._id && !customer_id) {
        this.carInfo.items = [{
          label: this.autocode_name,
          value: this.auto_id,
          auto_code: this.auto_code
        }]
        return;
      }
      
      const customerId = customer_id ? customer_id : profile._id;

      this.$store.dispatch('repair/getAutoItems', { customer_id: customerId })
      .then(({data}) => {
        this.carInfo.items = data.data.items.map(item => {
          const label = item.auto_number ? (' - ' + item.auto_number) : ''
          return {
            label: item.autocode_name + label,
            value: item._id,
            auto_code: item.auto_code
          }
        });
      })
    },
    clickNo () {
      return ;
    },
    async clickApply () {
      const key = this.resource_key || v4().replace(/-/g, "")
      for await (const file of this.uploadedArr) {
        if (file.file) {
          const _form = new FormData();
          _form.append( 'file', file.file)
          _form.append( 'tag', '수리견적요청')
          _form.append( 'key', key )
          await this.$store.dispatch('repair/uploadResources', _form)
        }
      }

      for await (const file of this.deleteUploadedArr) {
        if (file.id) {
          await this.$store.dispatch('repair/deleteUploadResource/' + file.id)
        }
      }

      const url = this.repairEstimateId ? 'repair/edit' : 'repair/create';
      const customer_id = this.$route.query.repairEstimateId ? this.$store.state.customer.profile._id : this.$route.query.customerId;
      const auto_id = this.selectedCar._id || this.selectedCar.value;
      const auto_code = this.selectedCar.auto_code || this.carInfo.items.find(car => car.value === auto_id).auto_code;

      let payload = {
        data: {
          customer_id,
          auto_id,
          auto_code,
          desired_area: this.address,
          repair_items: this.repairlist.filter(v => v.value).map(v => v.name.replace('<br>', '')).join(','),
          repair_estimate_type: this.repair_estimate_type,
          repair_estimate_status: '견적요청',
          repair_estimate_memo: this.reservation_memo,
          customer_phone_number: this.phoneNum,
          resource_key: key,
          repair_estimate_date: moment().format('YYYY-MM-DD HH:mm:ss')
        }
      };

      if (this.repairEstimateId) {
        payload.repairEstimateId = this.repairEstimateId;
      }

      this.$store.dispatch(url, payload).then(() => {
        this.success = true;
      })
    },
    clickOkay () {
      window.location.href = '/'
    },
    addressSearch () {
      this.dialog = true
    },
    searchAddress (result) {
			this.address = result.address
			this.dialog = false
    },
    handleUpload() {
      document.getElementById('upload-none').click();
    },
    selectedFile(e) {
      let input = e.target;
      let reader = new FileReader();

      reader.onload = (e) => {
        if (this.uploadedArr.find(upload => upload.result === e.target.result)) {
          alert('이미 선택된 파일입니다.');
        } else {
          this.uploadedArr.push({result: e.target.result, file: input.files[0]});
        }
      };

      reader.readAsDataURL(input.files[0]);
    },
    deleteFile(index) {
      this.deleteUploadedArr.push(...this.deleteUploadedArr, ...this.uploadedArr.splice(index, 1))
    },
    load_list(resource_key) {
      var _params = { "key": resource_key, "page": 1, "size": 100 }
      this.$store.dispatch("repair/getResourceItems", {params:_params}).then(res => {
        let { data, error } = res.data;
        if (error) { return;  }
        this.$data.originUploadedArr = data.items
        this.$data.uploadedArr = data.items.map(item => ({result: item.resource_url, id: item.id}))
      })
    },
  },
}
</script>

<style lang="scss">
.el-dialog__body {
  padding-top: 0px;
  padding-bottom: 15px;
}
.textarea-box-border {
  border-radius: 2px;
  margin-top: 5px;
  margin-bottom: 30px;
  border: 1px solid #D9D9D9;
  padding: 10px 15px 10px 15px;
}
.input-box-border {
  font-weight: bold;
  border-radius: 2px;
  margin-top: 5px;
  border: 1px solid #D9D9D9;
  padding: 10px 15px 10px 15px;
}
.siri-selectbox {
  margin-top: -10px;

  div.label {
    display: none;
  }
}
.add-address-btn {
  margin-top: 5px;
  margin-bottom: 20px;
  border: solid 1px #174be6;
  color: #174be6;
  padding: 12px 10px;
}
.add-address-btn2 {
  margin-bottom: 20px;
  margin-top: 5px;
  border: solid 1px black;
  color: black;
  padding: 12px 10px;
}
.select-repairlist {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top:5px;
  margin-bottom: 24px;
  color: black;
  font-weight: bold;
  font-family: 'NanumSquare', sans-serif;

  .repairlist-item {
    font-family: 'NanumSquare', sans-serif;
    display: flex;
    align-items: center;
    border: solid 1px #d9d9d9;
    border-radius: 2px;
    padding: 9px;
    cursor: pointer;
    width: 49%;
    height: 55px;
    margin-right: 1%;
    margin-bottom: 10px;
    padding-left: 18px;

    &:last-child {
      margin-right: 0;
    }

    .el-checkbox {
      display: flex;
      align-items: center;
      margin-right: 4px;

      .el-checkbox__input {
        display: none;
      }
      .el-checkbox__label {
        padding-left: 0;
      }
    }

    p {
      font-family: 'NanumSquareOTF', sans-serif;
      font-size: 15px;
      line-height: 18px;
    }
  }
}
.popupStyle-layout-2{
  max-width:1000px;
  height: 100vh;
  padding-bottom: 219px;
  display: flex;
  flex-flow: wrap;
  justify-content: center;
  margin: 0 auto;
  align-content: center;
}
.popupStyle-text-2{
  margin-top: 34px;
  width: 100%;
  font-size: 24px;
  font-weight: 400;
  line-height: 36px;
  color: #000000;
  text-align: center;
}
.popupStyle-text-3{
  margin-top: 34px;
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #666666;
}
</style>